import React from 'react';
import { useTranslation } from 'react-i18next';

interface ViewGoalDescriptionProps {
  description: string;
}

export const ViewGoalDescription: React.FC<ViewGoalDescriptionProps> = ({
  description,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 block">
        {t('descriptionLabel')}
      </label>
      <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
        {description}
      </p>
    </div>
  );
};
